import React from "react";
import { LeadModalsFragment } from "types/graphql-types";
import { match } from "ts-pattern";
import ExitIntentModal from "components/PageModals/ExitIntentModal";
import TimedModal from "components/PageModals/TimedModal";

export type SanityPageModal = LeadModalsFragment;

interface SanityPageModalsBuilderProps {
  modals: SanityPageModal[];
  sanityPageId: string;
}

const SanityPageModalsBuilder: React.FC<
  React.PropsWithChildren<SanityPageModalsBuilderProps>
> = ({ modals, sanityPageId }) => {
  return modals
    ? modals.map((x) => (
        <InternalPageModalsBuilder
          key={x._key!}
          {...x}
          sanityPageId={sanityPageId}
        />
      ))
    : null;
};

type InternalPageModalsBuilderProps = SanityPageModal & {
  sanityPageId: string;
};

const InternalPageModalsBuilder: React.FC<InternalPageModalsBuilderProps> = ({
  openingMode,
  sanityPageId,
  ...props
}) => {
  return match(openingMode)
    .with("timed", () => <TimedModal {...props} sanityPageId={sanityPageId} />)
    .with("exit_intent", () => (
      <ExitIntentModal {...props} sanityPageId={sanityPageId} />
    ))
    .otherwise(() => null);
};

export default SanityPageModalsBuilder;
